export const InviteBox = ({ className, children }: { className?: string; children: React.ReactNode }) => {
    return <div className={`flex flex-col px-2 sm:px-8 ${className ?? ''}`}>{children}</div>;
};
